import React from 'react';

import { kebabCase } from 'lodash-es';

import { Button, Text } from '@change/ds-core-ui';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';

import { Waypoint } from '#src/app/shared/components/scroll';
import { useTrackOnce } from '#src/app/shared/hooks/tracking';

import type { TaskShape } from '../../../../types';

type ActiveTaskProps = Omit<TaskShape, 'status'>;
export const ActiveTask: React.FC<ActiveTaskProps> = ({
	name,
	title,
	description,
	icon,
	primaryActionText,
	primaryActionHref,
	primaryActionOnClick,
}) => {
	const trackOnce = useTrackOnce();

	// Tech debt - this page is still using Legacy Icons, must be replaced to Sunrise Icons https://change.atlassian.net/browse/CHANGE-79089

	return (
		<div>
			<Waypoint onEnter={async () => trackOnce('petition_manage_tasks_view', { task: name, version: 'old' })} />
			<div data-qa="petition-task">
				<div className="flex gap-4 md:gap-6">
					<div className="bg-fill-information-weaker flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
						<Icon icon={icon} size={24} color="#4771ff" />
					</div>
					<div className="flex w-full flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
						<div className="flex flex-col gap-1">
							<Text
								data-qa={`task-title-${kebabCase(name)}`}
								variant="heading"
								className="text-size-body-bold md:text-size-heading-xs"
								as="h3"
							>
								{title}
							</Text>
							<Text
								data-qa={`task-description-${kebabCase(name)}`}
								variant="body"
								size="small"
								className="text-typography-weak"
								as="p"
							>
								{description}
							</Text>
						</div>
						<div sx={{ flexShrink: 0 }}>
							{primaryActionHref ? (
								<Button
									as="a"
									variant="secondary"
									size="x-small"
									href={primaryActionHref}
									onClick={primaryActionOnClick}
									data-qa={`task-action-button-${kebabCase(name)}`}
									className="min-w-[114px]"
								>
									{primaryActionText}
								</Button>
							) : (
								<Button
									variant="secondary"
									size="x-small"
									onClick={primaryActionOnClick}
									data-qa={`task-action-button-${kebabCase(name)}`}
									className="min-w-[114px]"
								>
									{primaryActionText}
								</Button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
